import React from "react";

function ButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="12.86"
      viewBox="0 0 85.04 54.7"
    >
      <path
        fill="#010101"
        d="M85.04 27.35L37.05 0v22.25H0v10.2h37.05V54.7z"
      ></path>
    </svg>
  );
}

export default ButtonIcon;
